import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import '../../../css/haftungsauschluss.css';
import '../../../css/datenschutzverordnung.css';

function TermsAndConditions() {
  const { t } = useTranslation();

  return (
    <>
      <div className="terms-and-conditions-page"> {/* Use the new, specific class */}
        <h1>{t("termsAndConditions.headings.liabilityDisclaimer")}</h1>
        <p className="p-terms">
          {t("termsAndConditions.sections.registrationAgreement")}
        </p>
        <h2>{t("termsAndConditions.headings.informationObligation")}</h2>
        <p className="p-terms">{t("termsAndConditions.sections.contentResponsibility")}</p>
        <p className="p-terms">{t("termsAndConditions.sections.calculationsDisclaimer")}</p>
        <h2>{t("termsAndConditions.headings.privacyPolicy")}</h2>
        <p className="p-terms">{t("termsAndConditions.sections.privacyPolicyIntro")}</p>
        <p className="p-terms">{t("termsAndConditions.sections.contactUs")}</p>
        <p className="p-terms">
          {t("termsAndConditions.sections.productDataStorage")}
        </p>
        <h2>{t("termsAndConditions.headings.googleFonts")}</h2>
        <p className="p-terms">{t("termsAndConditions.sections.googleFonts")}</p>
        <ul>
          {t("termsAndConditions.lists.googleFontsProvider", { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <p className="p-terms">{t("termsAndConditions.sections.googleFontsDetails")}</p>
        <p className="p-terms">{t("termsAndConditions.sections.googleFontsPurpose")}</p>
        <ul>
          <li>
            <Link className="login-link" to="https://developers.google.com/fonts/faq">
              https://developers.google.com/fonts/faq
            </Link>
          </li>
        </ul>
        <p className="p-terms">{t("termsAndConditions.sections.googleFontsPurpose")}</p>
        <ul>
          <li>
            <Link className="login-link" to="https://policies.google.com/privacy?hl=de">
              https://policies.google.com/privacy?hl=de
            </Link>
          </li>
        </ul>
        <h2>{t("termsAndConditions.headings.serverLogFiles")}</h2>
        <p className="p-terms">{t("termsAndConditions.sections.serverLogFiles")}</p>
        <ul>
          {t("termsAndConditions.lists.serverLogFiles", { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <h2>{t("termsAndConditions.headings.userRights")}</h2>
        <p className="p-terms">{t("termsAndConditions.sections.userRightsIntro")}</p>
        <ul>
          {t("termsAndConditions.lists.userRights", { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <p className="p-terms">
          {t("termsAndConditions.sections.complaint")} (
          <Link className="login-link" to="mailto:hannes@wendelin-weine.at">
            hannes@wendelin-weine.at
          </Link>
          )
        </p>
        <h2>{t("termsAndConditions.headings.contactUs")}</h2>
        <p className="p-terms">
          <b>{t("termsAndConditions.contact.operator")}</b>
          <br />
          {/* <b>{t("termsAndConditions.contact.phone")}</b>
          <br /> */}
          {/* <b>{t("termsAndConditions.contact.email")}</b>{' '} */}
          <Link className="login-link" to="mailto:hannes@wendelin-weine.at">
            hannes@wendelin-weine.at
          </Link>
        </p>
        <p className="p-terms">
          {t("termsAndConditions.sources.source")}{' '}
          <Link className="link-quelle" to="https://www.ortner-rechtsanwalt.at/rechtsanwalt-eherecht-scheidungsrecht-obsorgerecht/">
            Ortner Rechtsanwalts GmbH
          </Link>
        </p>
      </div>
    </>
  );
}

export default TermsAndConditions;